import {
  GET_LETTER_ORDERS_LIST_REQUEST,
  GET_LETTER_ORDERS_LIST_SUCCESS,
  GET_LETTER_ORDERS_LIST_FAILURE,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE,
  GET_DELAY_LETTER_ORDERS_REQUEST,
  GET_DELAY_LETTER_ORDERS_SUCCESS,
  GET_DELAY_LETTER_ORDERS_FAILURE,
} from '../../constants/ActionTypes'
import { LETTER_ORDER_PER_PAGE } from '../../constants/Constants';
import { LetterOrdersApi } from '../api/LetterOrdersApi';

/***  GET /letter-orders ***/
const getLetterOrderListRequest = (overwrite) => ({
  type: GET_LETTER_ORDERS_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getLetterOrderListSuccess = (data, pageInfo, overwrite) => ({
  type: GET_LETTER_ORDERS_LIST_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getLetterOrderListFailure = (error) => ({
  type: GET_LETTER_ORDERS_LIST_FAILURE,
  payload: {
    error: error
  }
});

export function getLetterOrderList(data = { 'paging': 1, 'page': 1, 'per_page': LETTER_ORDER_PER_PAGE }, overwrite) {
  return async (dispatch) => {

    let query = {
      ...data,
    }

    dispatch(getLetterOrderListRequest(overwrite));

    LetterOrdersApi.getLetterOrders({
      ...query,
    }, dispatch)
      .then((response) => {
        dispatch(getLetterOrderListSuccess(
          response.data.data,
          response.data.meta,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getLetterOrderListFailure(error.response));
      });
  };
}


/***  GET /letter-orders ***/
const getDelayLetterOrderListRequest = (overwrite) => ({
  type: GET_DELAY_LETTER_ORDERS_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getDelayLetterOrderListSuccess = (data, pageInfo, overwrite) => ({
  type: GET_DELAY_LETTER_ORDERS_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getDelayLetterOrderListFailure = (error) => ({
  type: GET_DELAY_LETTER_ORDERS_FAILURE,
  payload: {
    error: error
  }
});

export function getDelayLetterOrderList(data = { 'paging': 1, 'page': 1, 'per_page': LETTER_ORDER_PER_PAGE }, overwrite) {
  return async (dispatch) => {

    let query = {
      ...data,
    }

    dispatch(getDelayLetterOrderListRequest(overwrite));

    LetterOrdersApi.getLetterOrders({
      ...query,
    }, dispatch)
      .then((response) => {
        dispatch(getDelayLetterOrderListSuccess(
          response.data.data,
          response.data.meta,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getDelayLetterOrderListFailure(error.response));
      });
  };
}

/*** POST /letter-orders/salesforce/sync ***/
const postLetterOrdersSalesforceSyncRequest = () => ({
  type: POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST,
});

const postLetterOrdersSalesforceSyncSuccess = () => ({
  type: POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS,
});

const postLetterOrdersSalesforceSyncFailure = (error) => ({
  type: POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE,
  payload: {
    error: error
  }
});

export function postLetterOrdersSalesforceSync(data) {
  return async (dispatch) => {
    dispatch(postLetterOrdersSalesforceSyncRequest());

    LetterOrdersApi.postLetterOrdersSalesforceSync(data, dispatch)
      .then(() => {
        dispatch(postLetterOrdersSalesforceSyncSuccess());
      })
      .catch((error) => {
        dispatch(postLetterOrdersSalesforceSyncFailure(error.response));
      });
  };
}

const getLetterOrdersLetterContentCheckRequest = () => ({
  type: GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST,
});

const getLetterOrdersLetterContentCheckSuccess = (isCheckOK, checkMessage) => ({
  type: GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS,
  payload: {
    isCheckOK: isCheckOK,
    checkMessage: checkMessage
  }
});

const getLetterOrdersLetterContentCheckFailure = (error) => ({
  type: GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE,
  payload: {
    error: error
  }
});

export function getLetterOrdersLetterContentCheck(data) {
  return async (dispatch) => {
    dispatch(getLetterOrdersLetterContentCheckRequest());
    LetterOrdersApi.getLetterOrdersLetterContentCheck(data, dispatch)
      .then((response) => {
        let checkMessage = "";
        if (!response.data.data.is_match_season_greetings || !response.data.data.is_match_letter_include_name) {
          checkMessage += "AIがレター文面の誤りの可能性を検知しました。";

          let details = [];
          if (!response.data.data.is_match_season_greetings) {
            details.push("季節の挨拶");
          }
          if (!response.data.data.is_match_letter_include_name) {
            details.push("文面に記載された宛先の人名");
          }

          if (details.length > 0) {
            checkMessage += details.join("・") + "が記載されている場合、間違っていないか確認をお願いします。";
          }
        }
        dispatch(getLetterOrdersLetterContentCheckSuccess(response.data.data.is_match_season_greetings && response.data.data.is_match_letter_include_name, checkMessage));
      })
      .catch((error) => {
        dispatch(getLetterOrdersLetterContentCheckFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/LetterOrderList.js